import BrowserTabUidManager from '../../../../../../library/clxProductNet/assets/js/modules/common/tracking/browserTabUidManager';
import MicroConversionTracker from '../../../../../../library/clxProductNet/assets/js/modules/common/tracking/microConversionTracker';
import {RequestFailedError} from '../../common/errors';
import CustomizationOverviewMapper, {UpdatePricingOverviewResponse} from '../Integration/customizationOverviewMapper';
import CustomizationOverviewSkuAmountMapper, {OverviewChangeSkuAmountResponse} from '../Integration/customizationOverviewSkuAmountMapper';
import ProductCustomizationConfigModel from '../Model/productCustomizationConfigModel';
import ProductCustomizationTrackingModel from '../Model/productCustomizationTrackingModel';

export default class PricingOverviewService {
    private readonly microConversionTracker: MicroConversionTracker;
    private readonly customizationOverviewMapper: CustomizationOverviewMapper;
    private readonly browserTabUidManager: BrowserTabUidManager;
    private readonly customizationOverviewSkuAmountMapper: CustomizationOverviewSkuAmountMapper;

    constructor(microConversionTracker: MicroConversionTracker, browserTabUidManager: BrowserTabUidManager) {
        this.microConversionTracker = microConversionTracker;
        this.browserTabUidManager = browserTabUidManager;

        this.customizationOverviewMapper = new CustomizationOverviewMapper();
        this.customizationOverviewSkuAmountMapper = new CustomizationOverviewSkuAmountMapper();
    }

    async refreshOverviewUI(
        productCustomizationConfig: ProductCustomizationConfigModel,
        eventName: string,
    ): Promise<UpdatePricingOverviewResponse | RequestFailedError> {
        const response = await this.customizationOverviewMapper.fetchPricingOverview(
            productCustomizationConfig,
            this.browserTabUidManager.createBrowsertabUid(),
        );

        if (response instanceof RequestFailedError) {
            return response;
        }

        let trackingModel = new ProductCustomizationTrackingModel(productCustomizationConfig);
        this.microConversionTracker.trackWithBeacon(eventName, trackingModel.getAsJsonStringForTracking());

        return response;
    }

    async refreshOverviewPrices(
        productCustomizationConfig: ProductCustomizationConfigModel,
        eventName: string,
    ): Promise<OverviewChangeSkuAmountResponse | RequestFailedError> {
        const response = await this.customizationOverviewSkuAmountMapper.fetchPricingOverview(
            productCustomizationConfig,
            this.browserTabUidManager.createBrowsertabUid(),
        );

        if (response instanceof RequestFailedError) {
            return response;
        }

        return response;
    }
}
